import { AutogenLayoutPayee401kFundList } from "./autogen/AutogenLayoutPayee401kFundList";

export class Payee401kFundList extends AutogenLayoutPayee401kFundList {
    onLoad(): void | Promise<void> {
        this.mainDataSource.orderBy = [{ field: "descr", sort: "asc" }];
    }
}
